import { Tooltip } from '@/components/primitives/Tooltip'
import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'

type Props = {
  disabled?: boolean
  helperText?: string
}

export function CheckoutField(props: Props) {
  const { disabled: fieldDisabled, helperText } = props
  const texts = useTexts()
  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const disableField = submitting || disabled || fieldDisabled

  return (
    <form.Checkbox
      label={
        <Tooltip title={texts.requiredTooltip} placement="bottom" disabled={!disableField}>
          <>{texts.checkout}</>
        </Tooltip>
      }
      name="checkOut"
      validateOn="blur change"
      disabled={disableField}
      helperText={helperText}
      testId="driver-assistance-form-check-out-field"
    />
  )
}
